import styled from 'styled-components';

const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
`;

export default Section;
